import React from "react";
import { motion } from "framer-motion";
import { Clock, Search, Zap } from "lucide-react";
import { WhatsAppCTA } from "../WhatsAppCTA";
import { fadeUp, staggerContainer, viewport } from "../../lib/motion";

const CARDS = [
  {
    icon: Clock,
    main: "Agilidade",
    label: "Atendimento",
    description:
      "Sem burocracia. Chame, conte o que aconteceu e entenda o próximo passo.",
  },
  {
    icon: Search,
    main: "Avaliação clara",
    label: "Transparência",
    description: "Antes de qualquer serviço, você entende o que será feito.",
  },
  {
    icon: Zap,
    main: "Sem complicação",
    label: "Praticidade",
    description: "Uma conversa direta para entender o problema do seu aparelho.",
  },
];

export const Performance = () => {
  return (
    <section
      data-testid="performance-section"
      className="relative bg-[#050505] py-28 md:py-40"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="text-4xl md:text-6xl font-bold tracking-tighter text-[#f5f5f7] text-center max-w-3xl mx-auto"
        >
          Rápido como deve ser.
        </motion.h2>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6"
        >
          {CARDS.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={i}
                variants={fadeUp}
                data-testid={`performance-card-${i + 1}`}
                className="bento-card bg-[#1a1a1a] border border-white/[0.05] rounded-[28px] p-8 md:p-10 min-h-[300px] flex flex-col"
              >
                <div className="w-12 h-12 rounded-2xl bg-white/[0.04] border border-white/[0.06] flex items-center justify-center mb-8">
                  <Icon size={22} className="text-[#f5f5f7]" strokeWidth={1.8} />
                </div>
                <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#86868b]">
                  {card.label}
                </span>
                <h3 className="mt-2 text-2xl md:text-3xl font-bold tracking-tight text-[#f5f5f7]">
                  {card.main}
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-[#86868b]">
                  {card.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>

        <div className="mt-14 flex justify-center">
          <WhatsAppCTA label="Falar no WhatsApp" testId="performance-whatsapp" />
        </div>
      </div>
    </section>
  );
};
